module.exports = __webpack_public_path__ + "static/media/arrow-down.0e26a3e7.svg";